import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { SavedViewService } from 'features/saved-views/service/service'

export { SavedViewService } from 'features/saved-views/service/service'

export function useSavedViewService(): SavedViewService {
  const client = useApiClient()
  return useMemo(() => new SavedViewService(client), [client])
}
